<div class="profile-overlay" (click)="onOverlayClick()">
  <div class="profile-popup" (click)="$event.stopPropagation()">

    <!-- Card top: name + logout -->
    <div class="profile-popup-top">
      <h2 class="profile-full-name">{{ fullName }}</h2>
      <button class="profile-logout-btn" type="button" (click)="onLogout()">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
             fill="none" stroke="currentColor" stroke-width="2"
             stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
          <polyline points="16 17 21 12 16 7"/>
          <line x1="21" y1="12" x2="9" y2="12"/>
        </svg>
        Logout
      </button>
    </div>

    <!-- Section label -->
    <div class="profile-section-label">USER DETAILS</div>

    <!-- Fields -->
    <div class="profile-fields">

      <!-- Email/Enterprise ID – full width -->
      <div class="profile-field-row profile-field-row--full">
        <div class="profile-field">
          <span class="profile-field-label">Email/Enterprise ID</span>
          <span class="profile-field-value">{{ profileData?.Email || profileData?.EnterpriseID || '' }}</span>
        </div>
      </div>

      <!-- First Name | Last Name -->
      <div class="profile-field-row">
        <div class="profile-field">
          <span class="profile-field-label">First Name</span>
          <span class="profile-field-value">{{ profileData?.FirstName || '' }}</span>
        </div>
        <div class="profile-field">
          <span class="profile-field-label">Last Name</span>
          <span class="profile-field-value">{{ profileData?.LastName || '' }}</span>
        </div>
      </div>

      <!-- Is R&C Member | Sponsor -->
      <div class="profile-field-row">
        <div class="profile-field">
          <span class="profile-field-label">Is this R&amp;C Member?</span>
          <span class="profile-field-value">{{ isRCMember ? 'Yes' : 'No' }}</span>
        </div>
        <div class="profile-field">
          <span class="profile-field-label">Name of R&amp;C Sponsor</span>
          <span class="profile-field-value">{{ rcMemberSponsor }}</span>
        </div>
      </div>

      <!-- Country | Work Location -->
      <div class="profile-field-row">
        <div class="profile-field">
          <span class="profile-field-label">Country</span>
          <span class="profile-field-value">{{ country }}</span>
        </div>
        <div class="profile-field">
          <span class="profile-field-label">Work Location</span>
          <span class="profile-field-value">{{ workLocation }}</span>
        </div>
      </div>

      <!-- Role & Permission | Expiration On -->
      <div class="profile-field-row">
        <div class="profile-field">
          <span class="profile-field-label">Role &amp; Permission</span>
          <span class="profile-role-badge">{{ profileData?.RoleName || '' }}</span>
        </div>
        <div class="profile-field">
          <span class="profile-field-label">Expiration On</span>
          <span class="profile-field-value">{{ expirationDisplay }}</span>
        </div>
      </div>

      <!-- Active/Inactive -->
      <div class="profile-field-row">
        <div class="profile-field">
          <span class="profile-field-label">Active/Inactive</span>
          <span class="profile-status-badge"
                [class.profile-status-active]="isActive"
                [class.profile-status-inactive]="!isActive">
            {{ isActive ? 'Active' : 'Inactive' }}
          </span>
        </div>
      </div>

    </div>
  </div>
</div>
